import FooterView from './FooterView';
import GlobalNavView from './GlobalNavView';
import HeaderUserView from './HeaderUserView';
import HeaderView from './HeaderView';
import LoginView from './LoginView';
import ProgressListView from './ProgressListView';
import RegisterView from './RegisterView';
import ResetPasswordView from './ResetPasswordView';

export {
    FooterView,
    GlobalNavView,
    HeaderUserView,
    HeaderView,
    LoginView,
    ProgressListView,
    RegisterView,
    ResetPasswordView
};



// WEBPACK FOOTER //
// ./src/views/layout/index.js